import { io } from "socket.io-client";

const socket = io(process.env.VUE_APP_IO); // Instancia única de WebSocket

socket.on('connect', () => {
  console.log('Conexión establecida con el servidor WebSocket');
});

socket.on('connect_error', (error) => {
  console.error('Error de conexión: ', error);
});

export default {
  install(app) {
    app.config.globalProperties.$socket = socket; // Hacer accesible en toda la app
  }
};
